import { render, staticRenderFns } from "./MyDogRegistrationIndividualRequest.vue?vue&type=template&id=dcadce46"
import script from "./MyDogRegistrationIndividualRequest.vue?vue&type=script&lang=ts"
export * from "./MyDogRegistrationIndividualRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports